<script>
    export let style = "";
</script>

<div class='button-row' {style}>
    <slot/>
</div>

<style lang="scss">
    .button-row{
        margin: 0px auto;
        margin-top: 10px;
        display: flex;
        width: 100%;
        max-width: 600px;
        justify-content: space-around;
    }

    
</style>